import React from 'react';
import {connect} from "react-redux";
import getCustomerList from "../../actions/getCustomerList";
import {Form, Row, Col} from 'antd';
import MainLayout from "../Layout/Layout";
import showLogin from "../../actions/showLogin";
import getPKICertificatesReport from "../../actions/getPKICertificatesReport";
import {CustomerFilterItem, DateRangeFilterItem, ReportFilterActions, ReportFilterHeader} from "../ReportFilters/ReportFilters";
import {Typography} from "antd";

class PKICertificates extends React.Component
{
    componentDidMount()
    {
        if(!this.props.login.tokenId || !this.props.login.profileObj)
            this.props.showLogin();
        this.props.getCustomerList(1);
    }

    render()
    {
        const pkiInfo=this.props.pkiInfo;

        return <MainLayout title={'logo'} size={'medium'} variant="report"
                           reportTitle="Estado de Certificados"
                           reportDescription="Consulta métricas de certificados emitidos, vigentes, pendientes, revocados y expirados.">
            <Form className="report-filter-panel" layout="vertical" name="operations" onFinish={this.props.getPKICertificatesReport}>
                <ReportFilterHeader/>
                <div className="report-filter-fields">
                    <CustomerFilterItem customerList={this.props.customerList}/>
                    <DateRangeFilterItem/>
                </div>
                <ReportFilterActions>Consultar</ReportFilterActions>
            </Form>
            {pkiInfo?
                <div className="report-result-panel pki-result-panel">
                    <div className="report-result-header">
                        <div className="report-result-heading">
                            <Typography.Title level={3}>Resultados</Typography.Title>
                            <Typography.Text className="report-result-count">
                                Resumen de certificados por estado.
                            </Typography.Text>
                        </div>
                    </div>
                    <div className="pki-metric-table">
                        <Row className="pki-metric-row pki-metric-heading">
                            <Col xs={8} span={6}/>
                            <Col xs={5} span={6}>Activos</Col>
                            <Col xs={6} span={6}>Históricos</Col>
                            <Col xs={5} span={6}>Total</Col>
                        </Row>
                        {[
                            ['Emitidos', pkiInfo.issued, pkiInfo.issuedh],
                            ['Vigentes', pkiInfo.valid, pkiInfo.validh],
                            ['Pendientes', pkiInfo.pending, pkiInfo.pendingh],
                            ['Revocados', pkiInfo.revoked, pkiInfo.revokedh],
                            ['Expirados', pkiInfo.expired, pkiInfo.expiredh]
                        ].map(([label, active, historical])=>(
                            <Row className="pki-metric-row" key={label}>
                                <Col xs={8} span={6}>{label}</Col>
                                <Col xs={5} span={6}>{active}</Col>
                                <Col xs={6} span={6}>{historical}</Col>
                                <Col xs={5} span={6}>{Number(active || 0) + Number(historical || 0)}</Col>
                            </Row>
                        ))}
                    </div>
                </div>:''}
        </MainLayout>;
    }
}

function mapStateToProps(state) {
    return {
        login: state.login,
        customerList:state.customer.customerList,
        pkiInfo:state.pki.report
    }
}
export default connect(mapStateToProps, {getCustomerList,showLogin,getPKICertificatesReport})(PKICertificates);
